;(function () {
  'use strict'

  angular.module('deskfy.arts').controller('PublicFolderController', PublicFolderController)

  /* @ngInject */
  function PublicFolderController (
    $scope,
    $timeout,
    $translate,
    ShareLinkService,
    ToastService
  ) {
    $scope.flags = {
      loadingDate: false,
      loadingComment: false
    }
    $scope.form = {
      sharedLinkId: '',
      link: '',
      comment: '',
      expirationDate: null,
      expirationTime: null
    }

    $scope.linkCopied = false

    $scope.today = new Date().toISOString()

    $scope.hourOptions = []

    const api = {
      _getSharedLink,
      _generateLink
    }
    this.getApi = () => api

    function activate () {
      if ($scope.collection && $scope.collection.id) {
        api._getSharedLink($scope.collection.id)
      }

      const hourOptions = []
      for (let hour = 0; hour < 24; hour++) {
        const timeString = `${hour.toString().padStart(2, '0')}:00`
        hourOptions.push({
          label: timeString,
          value: timeString
        })
      }

      $scope.hourOptions = hourOptions
    }
    activate()

    const deregisterLoadPublicLinkData = $scope.$on('load-public-link-data', (_, data) => {
      $scope.art = data
      activate()
    })

    const deregisterPublicLinkCancelPublicLink = $scope.$on('publicLink.cancelPublicLink', () => {
      ShareLinkService.deleteShareLink($scope.form.sharedLinkId)
        .then(() => {
          $scope.form.sharedLinkId = null
          $scope.form.link = ''
          $scope.form.comment = ''
          $scope.form.expirationDate = null
          $scope.form.expirationTime = null
          $scope.buttons.disablePublicLink = false
          ToastService.showSuccessToast($translate.instant('sucessCancelLink'))
        })
        .catch(ToastService.defaultErrorToast)
    })

    const deregisterPublicLinkSavePublicFolder = $scope.$on('publicLink.savePublicFolder', () => {
      let expirationDateTime = null

      if ($scope.form.expirationDate) {
        const date = moment($scope.form.expirationDate)
        if ($scope.form.expirationTime && $scope.form.expirationTime.value) {
          const [hours, minutes] = $scope.form.expirationTime.value.split(':')
          date.hour(hours).minute(minutes)
        }
        expirationDateTime = date.toISOString()
      }

      const data = {
        ...$scope.form,
        expirationDate: expirationDateTime
      }

      ShareLinkService.update($scope.form.sharedLinkId, data)
        .then(() => {
          ToastService.showSuccessToast($translate.instant('saveSuccessfully'))
        })
        .catch(ToastService.defaultErrorToast)
    })

    $scope.$on('$destroy', () => {
      deregisterLoadPublicLinkData()
      deregisterPublicLinkCancelPublicLink()
      deregisterPublicLinkSavePublicFolder()
    })

    $scope.generateLink = collectionId => {
      api._generateLink(collectionId)
    }

    function _generateLink (collectionId) {
      ShareLinkService.createCollectionShareLink({ collectionId: collectionId }).then((shareLink) => {
        $scope.form.sharedLinkId = shareLink.id
        $scope.form.link = shareLink.url
        $scope.form.comment = shareLink.comment
        $scope.form.expirationDate = shareLink.expirationDate ? moment(shareLink.expirationDate) : null
        $scope.form.expirationTime = shareLink.expirationTime ? moment(shareLink.expirationTime) : null
        $scope.buttons.disablePublicLink = true
      }).catch(ToastService.defaultErrorToast)
    }

    $scope.updateDate = function (event) {
      $scope.form.expirationDate = event.detail.date || null
    }

    $scope.updateTime = function (event) {
      const timeValue = event.detail.value || null
      if (timeValue) {
        const matchingOption = $scope.hourOptions.find(option => option.value === timeValue)
        $scope.form.expirationTime = matchingOption || null
      } else {
        $scope.form.expirationTime = null
      }
    }

    $scope.copyLink = link => {
      navigator.clipboard.writeText(link)
      ToastService.showSuccessToast($translate.instant('copied'))

      $scope.linkCopied = true

      $timeout(() => {
        $scope.linkCopied = false
      }, 5000)
    }

    function _getSharedLink (collectionId) {
      return ShareLinkService.getCollectionShareLink(collectionId).then(sharedLink => {
        if (sharedLink) {
          const instructions = $scope.collection?.details?.suggestions || $scope.collection?.suggestions
          $scope.form.sharedLinkId = sharedLink.id
          $scope.form.link = sharedLink.url
          $scope.form.comment = instructions || sharedLink.comment
          $scope.form.expirationDate = sharedLink.expirationDate ? moment(sharedLink.expirationDate) : null
          if (sharedLink.expirationDate) {
            const timeString = moment(sharedLink.expirationDate).format('HH:mm')
            const matchingOption = $scope.hourOptions.find(option => option.value === timeString)
            $scope.form.expirationTime = matchingOption || null
          } else {
            $scope.form.expirationTime = null
          }
          $scope.buttons.disablePublicLink = true
        }
      }).catch((err) => {
        ToastService.defaultErrorToast()
        console.log(err)
      })
    }

    $scope.getCopyText = () => {
      return $scope.linkCopied ? $translate.instant('shareLink.copied') : $translate.instant('copy')
    }
  }
})()
